<template>
  <div>
    <div class="mb-2">{{ name }}</div>
    <a @click="setDeparture" class="button-secondary block p-1 mb-2">{{$t('tour_set_departure')}}</a>
    <a @click="setArrival" class="button-secondary block p-1 mb-2">{{$t('tour_set_arrival')}}</a>
    <div class="border border-gray-300">
      <p class="text-xs">
        {{$t('tour_position_message')}}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  methods: {
    setDeparture: function () {
      this.$store.dispatch('reservation/updateDeparturePosition')
    },
    setArrival: function () {
      this.$store.dispatch('reservation/updateArrivalPosition')
    }
  },
  computed: {
    ...mapGetters({
      busstop: 'drawer/getTarget',
      position: 'reservation/getPosition'
    }),
    name: function () {
      const { name } = this.position
      const s = name && name.length > 8 ? name.substring(0, 8) + '...' : name

      return s
    }
  }
}
</script>
